import { Outlet } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SignupPromos from "@/components/SignupPromos";
import WelcomeNote from "@/components/WelcomeNote";
import GamifyTracker from "@/components/GamifyTracker";
import Seo from "@/components/Seo";
import ContentGate from "@/components/ContentGate";
import ContentDisclaimer from "@/components/ContentDisclaimer";
import ScrollTopButton from "@/components/ScrollTopButton";
import LangFallbackNotice from "@/components/LangFallbackNotice";

export default function Layout() {
  return (
    <div className="relative flex min-h-screen flex-col bg-parchment">
      <Seo />
      <ContentGate />
      <Header />
      <LangFallbackNotice />
      <SignupPromos />
      <GamifyTracker />
      <main className="relative z-[2] flex-1">
        <ContentDisclaimer />
        <Outlet />
      </main>
      <Footer />
      <WelcomeNote />
      <ScrollTopButton />
    </div>
  );
}
